export const DELIVERY_STATUS = {
  agendada: { label: "Agendada", cls: "bg-blue-600" },
  em_rota: { label: "Em rota", cls: "bg-amber-500" },
  entregue: { label: "Entregue", cls: "bg-green-600" },
  cancelada: { label: "Cancelada", cls: "bg-gray-500" },
};

export const todayBR = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Sao_Paulo" });
export const addDays = (ymd, n) => {
  const d = new Date(`${ymd}T12:00:00`);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};
export const fmtYmd = (ymd) => (ymd ? ymd.split("-").reverse().join("/") : "");
export const weekdayBR = (ymd) => new Date(`${ymd}T12:00:00`).toLocaleDateString("pt-BR", { weekday: "long" });

const toUtc = (iso) => (typeof iso === "string" && !(iso.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(iso)) ? iso + "Z" : iso);
export const fmtDateTimeBR = (iso) => (iso ? new Date(toUtc(iso)).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" }) : "");

const num = (n) => String(n || "").padStart(4, "0");

export const deliveryWhatsAppUrl = (d, companyName, kind) => {
  const digits = (d.contact_phone || "").replace(/\D/g, "");
  const phone = digits ? (digits.length <= 11 ? `55${digits}` : digits) : "";
  const items = (d.items || []).map((i) => `• ${i.quantity} ${i.unit || ""} ${(i.product_name || "").trim()}`).join("\n");
  d = { ...d, client_name: (d.client_name || "").trim() };
  const msg = kind === "entregue"
    ? `Olá, ${d.client_name}! Seu pedido #${num(d.sale_number)} da ${companyName} foi ENTREGUE em ${fmtDateTimeBR(d.delivered_at)}, recebido por ${d.received_by}.\n${items}\nObrigado pela preferência!`
    : kind === "em_rota"
      ? `Olá, ${d.client_name}! Seu pedido #${num(d.sale_number)} da ${companyName} SAIU PARA ENTREGA e chega hoje no endereço: ${d.address}.\n${items}`
      : `Olá, ${d.client_name}! A entrega do seu pedido #${num(d.sale_number)} da ${companyName} está agendada para ${fmtYmd(d.scheduled_date)} no endereço: ${d.address}.\n${items}`;
  return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
};
